import { VueConstructor } from 'vue';

import vclickoutside from './directives/v-click-outside/v-click-outside';
import vdebounce from './directives/v-debounce/v-debounce';
import vmutationobserver from './directives/v-mutation-observer/v-mutation-observer';
import vresize from './directives/v-resize/v-resize';
import vscroll from './directives/v-scroll/v-scroll';
import vtouch from './directives/v-touch/v-touch';

export default {
  install: (Vue: VueConstructor, options: any) => {
    Vue.use(vclickoutside);
    Vue.use(vdebounce);
    Vue.use(vmutationobserver);
    Vue.use(vresize);
    Vue.use(vscroll);
    Vue.use(vtouch);
  },
};
